import { Page, Left, Right, HeaderRow, RoleListContainer, RoleItem, SearchInput } from "../styles/component.style";
import { BtnGeneral } from "../../../../styles/Buttons";
import SearchableSelect from "../../../../components/Common/SearchableSelect";
import { useSede } from "../../../../hooks/useSede";

export default function Sede() {
    const {
        sedes,
        empresas,
        search,
        setSearch,
        selected,
        form,
        setForm,
        departamentos,
        municipios,
        handleSelect,
        handleNew,
        saveSede,
    } = useSede();

    const filtered = sedes.filter((s) =>
        (s.nombreSede || "").toLowerCase().includes(search.toLowerCase()) ||
        (s.ciudad || "").toLowerCase().includes(search.toLowerCase())
    );

    return (
        <Page>
            {/* IZQUIERDA */}
            <Left>
                <HeaderRow>
                    <h3>Sedes</h3>
                    <BtnGeneral bg="cyan" padding="6px 10px" radius="6px" fw="600" onClick={handleNew}>Nueva</BtnGeneral>
                </HeaderRow>
                <SearchInput placeholder="Buscar..." value={search} onChange={(e) => setSearch(e.target.value)} />
                <RoleListContainer>
                    {filtered.map((s) => (
                        <RoleItem key={s.id} active={selected === s.id} onClick={() => handleSelect(s)}>
                            <strong>{s.nombreSede}</strong><br />
                            <small>{s.nombreEmpresa} — {s.ciudad}</small>
                        </RoleItem>
                    ))}
                </RoleListContainer>
            </Left>

            {/* DERECHA */}
            <Right>
                <HeaderRow>
                    <h3>{form.id ? "Editar Sede" : "Nueva Sede"}</h3>
                    <BtnGeneral bg="green" padding="6px 10px" radius="6px" fw="600" onClick={saveSede}>Guardar</BtnGeneral>
                </HeaderRow>

                <div style={{ display: "flex", gap: "20px" }}>
                    <div style={{ flex: 1 }}>
                        <label>Empresa</label>
                        <SearchableSelect
                            value={form.id_empresa ? String(form.id_empresa) : ""}
                            onValueChange={(val) => setForm({ ...form, id_empresa: val })}
                            options={empresas}
                            getOptionValue={(e) => String(e.id)}
                            getOptionLabel={(e) => e.nombre}
                            placeholder="Seleccione empresa..."
                            multiple={false}
                            searchable={true}
                            size="small"
                            sx={{ mb: "12px", ...selectSx }}
                        />
                        <label>Nombre Sede</label>
                        <input style={inp} value={form.nombreSede} onChange={(e) => setForm({ ...form, nombreSede: e.target.value })} />
                        <label>Código Habilitación</label>
                        <input style={inp} value={form.codigoSede} onChange={(e) => setForm({ ...form, codigoSede: e.target.value })} />
                        <label>Departamento</label>
                        <SearchableSelect
                            value={form.id_dept ? String(form.id_dept) : ""}
                            onValueChange={(val) => setForm({ ...form, id_dept: val, id_muni: "" })}
                            options={departamentos}
                            getOptionValue={(d) => String(d.id)}
                            getOptionLabel={(d) => d.descripcion}
                            placeholder="Seleccione departamento..."
                            multiple={false}
                            searchable={true}
                            size="small"
                            sx={{ mb: "12px", ...selectSx }}
                        />
                        <label>Municipio / Ciudad</label>
                        <SearchableSelect
                            value={form.id_muni ? String(form.id_muni) : ""}
                            onValueChange={(val) => setForm({ ...form, id_muni: val })}
                            options={municipios}
                            getOptionValue={(m) => String(m.codigo)}
                            getOptionLabel={(m) => m.descripcion}
                            placeholder="Seleccione municipio..."
                            multiple={false}
                            searchable={true}
                            size="small"
                            sx={{ mb: "12px", ...selectSx }}
                        />
                    </div>
                    <div style={{ flex: 1 }}>
                        <label>Dirección</label>
                        <input style={inp} value={form.direccion} onChange={(e) => setForm({ ...form, direccion: e.target.value })} />
                        <label>Teléfono</label>
                        <input style={inp} value={form.telefono} onChange={(e) => setForm({ ...form, telefono: e.target.value })} />
                        <label>Estado</label>
                        <SearchableSelect
                            value={String(form.estado ?? 1)}
                            onValueChange={(val) => setForm({ ...form, estado: Number(val) })}
                            options={[
                                { value: "1", label: "ACTIVO" },
                                { value: "0", label: "INACTIVO" },
                            ]}
                            multiple={false}
                            searchable={false}
                            size="small"
                            sx={{ mb: "12px", ...selectSx }}
                        />
                    </div>
                </div>
            </Right>
        </Page>
    );
}

const inp = { width: "100%", padding: "8px", marginBottom: "12px", borderRadius: "6px", border: "1px solid #cbd5e1", boxSizing: "border-box" };

const selectSx = {
  width: "100%",
  "& .MuiOutlinedInput-root": {
    borderRadius: "6px",
    fontSize: "13px",
    fontFamily: "var(--font-body)",
    backgroundColor: "#ffffff",
    "& fieldset": { borderColor: "#cbd5e1" },
    "&:hover fieldset": { borderColor: "#94a3b8" },
    "&.Mui-focused fieldset": { borderColor: "#007bba" },
  },
  "& .MuiSelect-select": {
    padding: "8px 12px !important",
    fontSize: "13px",
    fontFamily: "var(--font-body)",
  },
};
